/* AUTO-GENERATED FILE. DO NOT EDIT. TO UPDATE PLEASE RUN :-
** yarn run generate:icons
** THIS GETS EXECUTED ON PREBUILD AND PREDEV
**
** LAST GENERATED: Mon Aug 10 2026 03:28:34 GMT+0000 (Coordinated Universal Time)
*/

import { ReactComponent as AcceptRequestIcon } from "./icons/accept-request.svg";
import { ReactComponent as AddressFinderIcon } from "./icons/address-finder.svg";
import { ReactComponent as AlertTriangleIcon } from "./icons/alert-triangle.svg";
import { ReactComponent as ArchiveIcon } from "./icons/archive.svg";
import { ReactComponent as ArrowDownIcon } from "./icons/arrow-down.svg";
import { ReactComponent as ArrowRightIcon } from "./icons/arrow-right.svg";
import { ReactComponent as ArrowRightIosIcon } from "./icons/arrow-right-ios.svg";
import { ReactComponent as ArrowUpRightIcon } from "./icons/arrow-up-right.svg";
import { ReactComponent as AwaitingIcon } from "./icons/awaiting.svg";
import { ReactComponent as BillCalendarIcon } from "./icons/bill-calendar.svg";
import { ReactComponent as BillCcIcon } from "./icons/bill-cc.svg";
import { ReactComponent as BriefcaseIcon } from "./icons/briefcase.svg";
import { ReactComponent as Building07Icon } from "./icons/building-07.svg";
import { ReactComponent as CalendarIcon } from "./icons/calendar.svg";
import { ReactComponent as CheckIcon } from "./icons/check.svg";
import { ReactComponent as CheckBoxIcon } from "./icons/check-box.svg";
import { ReactComponent as CheckCircleIcon } from "./icons/check-circle.svg";
import { ReactComponent as CheckCircleBlueIcon } from "./icons/check-circle-blue.svg";
import { ReactComponent as CheckLightIcon } from "./icons/check-light.svg";
import { ReactComponent as CheckOnlyIcon } from "./icons/check-only.svg";
import { ReactComponent as CheckVerifiedIcon } from "./icons/check-verified.svg";
import { ReactComponent as CheckboxCheckIcon } from "./icons/checkbox-check.svg";
import { ReactComponent as CheckboxUncheckedIcon } from "./icons/checkbox-unchecked.svg";
import { ReactComponent as ChevronRightIcon } from "./icons/chevron-right.svg";
import { ReactComponent as ClockIcon } from "./icons/clock.svg";
import { ReactComponent as CloseIcon } from "./icons/close.svg";
import { ReactComponent as CloudIcon } from "./icons/cloud.svg";
import { ReactComponent as ColumnsIcon } from "./icons/columns.svg";
import { ReactComponent as CompanyProfileIcon } from "./icons/company-profile.svg";
import { ReactComponent as CopyIcon } from "./icons/copy.svg";
import { ReactComponent as CornerUpLeftIcon } from "./icons/corner-up-left.svg";
import { ReactComponent as CsvIcon } from "./icons/csv.svg";
import { ReactComponent as DashboardIcon } from "./icons/dashboard.svg";
import { ReactComponent as DateSelectionIcon } from "./icons/date-selection.svg";
import { ReactComponent as DeclineRequestIcon } from "./icons/decline-request.svg";
import { ReactComponent as DeclinedIcon } from "./icons/declined.svg";
import { ReactComponent as DeleteIcon } from "./icons/delete.svg";
import { ReactComponent as DocIcon } from "./icons/doc.svg";
import { ReactComponent as DocumentIcon } from "./icons/document.svg";
import { ReactComponent as DocxIcon } from "./icons/docx.svg";
import { ReactComponent as DotsThreeIcon } from "./icons/dots-three.svg";
import { ReactComponent as DotsVerticalIcon } from "./icons/dots-vertical.svg";
import { ReactComponent as DownloadIcon } from "./icons/download.svg";
import { ReactComponent as DragIcon } from "./icons/drag.svg";
import { ReactComponent as DropdownIcon } from "./icons/dropdown.svg";
import { ReactComponent as EditIcon } from "./icons/edit.svg";
import { ReactComponent as EnvelopeIcon } from "./icons/envelope.svg";
import { ReactComponent as EyeIcon } from "./icons/eye.svg";
import { ReactComponent as EyeOffIcon } from "./icons/eye-off.svg";
import { ReactComponent as EyeOnIcon } from "./icons/eye-on.svg";
import { ReactComponent as EyeSlashIcon } from "./icons/eye-slash.svg";
import { ReactComponent as FavoriteIcon } from "./icons/favorite.svg";
import { ReactComponent as FileIcon } from "./icons/file.svg";
import { ReactComponent as FileAttachment04Icon } from "./icons/file-attachment-04.svg";
import { ReactComponent as FilterIcon } from "./icons/filter.svg";
import { ReactComponent as FlipBackwardIcon } from "./icons/flip-backward.svg";
import { ReactComponent as FolderPlusIcon } from "./icons/folder-plus.svg";
import { ReactComponent as GuestInviteIcon } from "./icons/guest-invite.svg";
import { ReactComponent as HandleCornerIcon } from "./icons/handle-corner.svg";
import { ReactComponent as HelpIcon } from "./icons/help.svg";
import { ReactComponent as HouseIcon } from "./icons/house.svg";
import { ReactComponent as InfoIcon } from "./icons/info.svg";
import { ReactComponent as Info2Icon } from "./icons/info2.svg";
import { ReactComponent as InprogressIcon } from "./icons/inprogress.svg";
import { ReactComponent as JpegIcon } from "./icons/jpeg.svg";
import { ReactComponent as ListViewIcon } from "./icons/list-view.svg";
import { ReactComponent as LockIcon } from "./icons/lock.svg";
import { ReactComponent as LogoutIcon } from "./icons/logout.svg";
import { ReactComponent as MultipleChoiceIcon } from "./icons/multiple-choice.svg";
import { ReactComponent as OpenInNewWindowIcon } from "./icons/open-in-new-window.svg";
import { ReactComponent as PaperPlaneIcon } from "./icons/paper-plane.svg";
import { ReactComponent as PaperclipIcon } from "./icons/paperclip.svg";
import { ReactComponent as ParagraphIcon } from "./icons/paragraph.svg";
import { ReactComponent as PauseSquareIcon } from "./icons/pause-square.svg";
import { ReactComponent as PdfIcon } from "./icons/pdf.svg";
import { ReactComponent as Pencil02Icon } from "./icons/pencil-02.svg";
import { ReactComponent as PlusIcon } from "./icons/plus.svg";
import { ReactComponent as PlusBlueIcon } from "./icons/plus-blue.svg";
import { ReactComponent as PlusCircleIcon } from "./icons/plus-circle.svg";
import { ReactComponent as PlusSquareIcon } from "./icons/plus-square.svg";
import { ReactComponent as PngIcon } from "./icons/png.svg";
import { ReactComponent as ProfileIcon } from "./icons/profile.svg";
import { ReactComponent as ProjectsIcon } from "./icons/projects.svg";
import { ReactComponent as QuoteTypeIcon } from "./icons/quote-type.svg";
import { ReactComponent as RedCircleTrashIcon } from "./icons/red-circle-trash.svg";
import { ReactComponent as RefreshIcon } from "./icons/refresh.svg";
import { ReactComponent as RequestIcon } from "./icons/request.svg";
import { ReactComponent as Save01Icon } from "./icons/save-01.svg";
import { ReactComponent as SearchIcon } from "./icons/search.svg";
import { ReactComponent as SearchLgIcon } from "./icons/search-lg.svg";
import { ReactComponent as SearchSmIcon } from "./icons/search-sm.svg";
import { ReactComponent as SectionIcon } from "./icons/section.svg";
import { ReactComponent as SettingsIcon } from "./icons/settings.svg";
import { ReactComponent as ShortAnswerIcon } from "./icons/short-answer.svg";
import { ReactComponent as SingleOptionIcon } from "./icons/single-option.svg";
import { ReactComponent as SixDotsVerticalIcon } from "./icons/six-dots-vertical.svg";
import { ReactComponent as StarsIcon } from "./icons/stars.svg";
import { ReactComponent as SupplierListIcon } from "./icons/supplier-list.svg";
import { ReactComponent as SwitchHorizontalIcon } from "./icons/switch-horizontal.svg";
import { ReactComponent as TemplateIcon } from "./icons/template.svg";
import { ReactComponent as TextInputIcon } from "./icons/text-input.svg";
import { ReactComponent as TickIcon } from "./icons/tick.svg";
import { ReactComponent as ToastCloseIcon } from "./icons/toast-close.svg";
import { ReactComponent as ToastErrorIcon } from "./icons/toast-error.svg";
import { ReactComponent as ToastSuccessIcon } from "./icons/toast-success.svg";
import { ReactComponent as TrashIcon } from "./icons/trash.svg";
import { ReactComponent as Trash03Icon } from "./icons/trash-03.svg";
import { ReactComponent as TrashStrokeIcon } from "./icons/trash-stroke.svg";
import { ReactComponent as UploadIcon } from "./icons/upload.svg";
import { ReactComponent as UploadFileIcon } from "./icons/upload-file.svg";
import { ReactComponent as User03Icon } from "./icons/user-03.svg";
import { ReactComponent as VerifiedIcon } from "./icons/verified.svg";
import { ReactComponent as ViewIcon } from "./icons/view.svg";
import { ReactComponent as XSquareIcon } from "./icons/x-square.svg";
import { ReactComponent as XlsxIcon } from "./icons/xlsx.svg";
import { ReactComponent as ZipIcon } from "./icons/zip.svg";

export const allIcons = {
 "accept-request": (props) => <AcceptRequestIcon {...props} />,
 "address-finder": (props) => <AddressFinderIcon {...props} />,
 "alert-triangle": (props) => <AlertTriangleIcon {...props} />,
 "archive": (props) => <ArchiveIcon {...props} />,
 "arrow-down": (props) => <ArrowDownIcon {...props} />,
 "arrow-right": (props) => <ArrowRightIcon {...props} />,
 "arrow-right-ios": (props) => <ArrowRightIosIcon {...props} />,
 "arrow-up-right": (props) => <ArrowUpRightIcon {...props} />,
 "awaiting": (props) => <AwaitingIcon {...props} />,
 "bill-calendar": (props) => <BillCalendarIcon {...props} />,
 "bill-cc": (props) => <BillCcIcon {...props} />,
 "briefcase": (props) => <BriefcaseIcon {...props} />,
 "building-07": (props) => <Building07Icon {...props} />,
 "calendar": (props) => <CalendarIcon {...props} />,
 "check": (props) => <CheckIcon {...props} />,
 "check-box": (props) => <CheckBoxIcon {...props} />,
 "check-circle": (props) => <CheckCircleIcon {...props} />,
 "check-circle-blue": (props) => <CheckCircleBlueIcon {...props} />,
 "check-light": (props) => <CheckLightIcon {...props} />,
 "check-only": (props) => <CheckOnlyIcon {...props} />,
 "check-verified": (props) => <CheckVerifiedIcon {...props} />,
 "checkbox-check": (props) => <CheckboxCheckIcon {...props} />,
 "checkbox-unchecked": (props) => <CheckboxUncheckedIcon {...props} />,
 "chevron-down": (props) => <ChevronRightIcon {...props} style={{ transform: "rotate(90deg)" }} />,
 "chevron-left": (props) => <ChevronRightIcon {...props} style={{ transform: "rotate(180deg)" }} />,
 "chevron-right": (props) => <ChevronRightIcon {...props} />,
 "chevron-up": (props) => <ChevronRightIcon {...props} style={{ transform: "rotate(270deg)" }} />,
 "clock": (props) => <ClockIcon {...props} />,
 "close": (props) => <CloseIcon {...props} />,
 "cloud": (props) => <CloudIcon {...props} />,
 "columns": (props) => <ColumnsIcon {...props} />,
 "company-profile": (props) => <CompanyProfileIcon {...props} />,
 "copy": (props) => <CopyIcon {...props} />,
 "corner-up-left": (props) => <CornerUpLeftIcon {...props} />,
 "csv": (props) => <CsvIcon {...props} />,
 "dashboard": (props) => <DashboardIcon {...props} />,
 "date-selection": (props) => <DateSelectionIcon {...props} />,
 "decline-request": (props) => <DeclineRequestIcon {...props} />,
 "declined": (props) => <DeclinedIcon {...props} />,
 "delete": (props) => <DeleteIcon {...props} />,
 "doc": (props) => <DocIcon {...props} />,
 "document": (props) => <DocumentIcon {...props} />,
 "docx": (props) => <DocxIcon {...props} />,
 "dots-three": (props) => <DotsThreeIcon {...props} />,
 "dots-vertical": (props) => <DotsVerticalIcon {...props} />,
 "download": (props) => <DownloadIcon {...props} />,
 "drag": (props) => <DragIcon {...props} />,
 "dropdown": (props) => <DropdownIcon {...props} />,
 "edit": (props) => <EditIcon {...props} />,
 "envelope": (props) => <EnvelopeIcon {...props} />,
 "eye": (props) => <EyeIcon {...props} />,
 "eye-off": (props) => <EyeOffIcon {...props} />,
 "eye-on": (props) => <EyeOnIcon {...props} />,
 "eye-slash": (props) => <EyeSlashIcon {...props} />,
 "favorite": (props) => <FavoriteIcon {...props} />,
 "file": (props) => <FileIcon {...props} />,
 "file-attachment-04": (props) => <FileAttachment04Icon {...props} />,
 "filter": (props) => <FilterIcon {...props} />,
 "flip-backward": (props) => <FlipBackwardIcon {...props} />,
 "folder-plus": (props) => <FolderPlusIcon {...props} />,
 "guest-invite": (props) => <GuestInviteIcon {...props} />,
 "handle-corner": (props) => <HandleCornerIcon {...props} />,
 "help": (props) => <HelpIcon {...props} />,
 "house": (props) => <HouseIcon {...props} />,
 "info": (props) => <InfoIcon {...props} />,
 "info2": (props) => <Info2Icon {...props} />,
 "inprogress": (props) => <InprogressIcon {...props} />,
 "jpeg": (props) => <JpegIcon {...props} />,
 "jpg": (props) => <JpegIcon {...props} />,
 "list-view": (props) => <ListViewIcon {...props} />,
 "lock": (props) => <LockIcon {...props} />,
 "logout": (props) => <LogoutIcon {...props} />,
 "multiple-choice": (props) => <MultipleChoiceIcon {...props} />,
 "open-in-new-window": (props) => <OpenInNewWindowIcon {...props} />,
 "paper-plane": (props) => <PaperPlaneIcon {...props} />,
 "paperclip": (props) => <PaperclipIcon {...props} />,
 "paragraph": (props) => <ParagraphIcon {...props} />,
 "pause-square": (props) => <PauseSquareIcon {...props} />,
 "pdf": (props) => <PdfIcon {...props} />,
 "pencil-02": (props) => <Pencil02Icon {...props} />,
 "plus": (props) => <PlusIcon {...props} />,
 "plus-blue": (props) => <PlusBlueIcon {...props} />,
 "plus-circle": (props) => <PlusCircleIcon {...props} />,
 "plus-square": (props) => <PlusSquareIcon {...props} />,
 "png": (props) => <PngIcon {...props} />,
 "profile": (props) => <ProfileIcon {...props} />,
 "projects": (props) => <ProjectsIcon {...props} />,
 "quote-type": (props) => <QuoteTypeIcon {...props} />,
 "red-circle-trash": (props) => <RedCircleTrashIcon {...props} />,
 "refresh": (props) => <RefreshIcon {...props} />,
 "request": (props) => <RequestIcon {...props} />,
 "save-01": (props) => <Save01Icon {...props} />,
 "search": (props) => <SearchIcon {...props} />,
 "search-lg": (props) => <SearchLgIcon {...props} />,
 "search-sm": (props) => <SearchSmIcon {...props} />,
 "section": (props) => <SectionIcon {...props} />,
 "settings": (props) => <SettingsIcon {...props} />,
 "short-answer": (props) => <ShortAnswerIcon {...props} />,
 "single-option": (props) => <SingleOptionIcon {...props} />,
 "six-dots-vertical": (props) => <SixDotsVerticalIcon {...props} />,
 "stars": (props) => <StarsIcon {...props} />,
 "supplier-list": (props) => <SupplierListIcon {...props} />,
 "switch-horizontal": (props) => <SwitchHorizontalIcon {...props} />,
 "template": (props) => <TemplateIcon {...props} />,
 "text-input": (props) => <TextInputIcon {...props} />,
 "tick": (props) => <TickIcon {...props} />,
 "toast-close": (props) => <ToastCloseIcon {...props} />,
 "toast-error": (props) => <ToastErrorIcon {...props} />,
 "toast-success": (props) => <ToastSuccessIcon {...props} />,
 "trash": (props) => <TrashIcon {...props} />,
 "trash-03": (props) => <Trash03Icon {...props} />,
 "trash-stroke": (props) => <TrashStrokeIcon {...props} />,
 "upload": (props) => <UploadIcon {...props} />,
 "upload-file": (props) => <UploadFileIcon {...props} />,
 "user-03": (props) => <User03Icon {...props} />,
 "verified": (props) => <VerifiedIcon {...props} />,
 "view": (props) => <ViewIcon {...props} />,
 "x-square": (props) => <XSquareIcon {...props} />,
 "xlsx": (props) => <XlsxIcon {...props} />,
 "zip": (props) => <ZipIcon {...props} />,
};

export type IconName =
  "accept-request" |
  "address-finder" |
  "alert-triangle" |
  "archive" |
  "arrow-down" |
  "arrow-right" |
  "arrow-right-ios" |
  "arrow-up-right" |
  "awaiting" |
  "bill-calendar" |
  "bill-cc" |
  "briefcase" |
  "building-07" |
  "calendar" |
  "check" |
  "check-box" |
  "check-circle" |
  "check-circle-blue" |
  "check-light" |
  "check-only" |
  "check-verified" |
  "checkbox-check" |
  "checkbox-unchecked" |
  "chevron-down" |
  "chevron-left" |
  "chevron-right" |
  "chevron-up" |
  "clock" |
  "close" |
  "cloud" |
  "columns" |
  "company-profile" |
  "copy" |
  "corner-up-left" |
  "csv" |
  "dashboard" |
  "date-selection" |
  "decline-request" |
  "declined" |
  "delete" |
  "doc" |
  "document" |
  "docx" |
  "dots-three" |
  "dots-vertical" |
  "download" |
  "drag" |
  "dropdown" |
  "edit" |
  "envelope" |
  "eye" |
  "eye-off" |
  "eye-on" |
  "eye-slash" |
  "favorite" |
  "file" |
  "file-attachment-04" |
  "filter" |
  "flip-backward" |
  "folder-plus" |
  "guest-invite" |
  "handle-corner" |
  "help" |
  "house" |
  "info" |
  "info2" |
  "inprogress" |
  "jpeg" |
  "jpg" |
  "list-view" |
  "lock" |
  "logout" |
  "multiple-choice" |
  "open-in-new-window" |
  "paper-plane" |
  "paperclip" |
  "paragraph" |
  "pause-square" |
  "pdf" |
  "pencil-02" |
  "plus" |
  "plus-blue" |
  "plus-circle" |
  "plus-square" |
  "png" |
  "profile" |
  "projects" |
  "quote-type" |
  "red-circle-trash" |
  "refresh" |
  "request" |
  "save-01" |
  "search" |
  "search-lg" |
  "search-sm" |
  "section" |
  "settings" |
  "short-answer" |
  "single-option" |
  "six-dots-vertical" |
  "stars" |
  "supplier-list" |
  "switch-horizontal" |
  "template" |
  "text-input" |
  "tick" |
  "toast-close" |
  "toast-error" |
  "toast-success" |
  "trash" |
  "trash-03" |
  "trash-stroke" |
  "upload" |
  "upload-file" |
  "user-03" |
  "verified" |
  "view" |
  "x-square" |
  "xlsx" |
  "zip";
